<template>
  <tr v-show="!(fieldName === '' && file === null)">
    <td :class='label'>{{ fieldName }}</td>
    <td style='white-space: nowrap;' class='text-right' v-if="file !== null">
      <v-btn icon @click='downloadFile'>
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <v-btn v-if='!disabled' icon @click='openRemoveModal'>
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </td>
    <td class='text-right' v-else>
      <v-btn v-if='!disabled' icon @click='showFileUploadModal = true; fileToBeUploaded = undefined'>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </td>
    <wc-dialog
      width='350'
      :showDialog='showFileUploadModal'
      :disableButtons='!isFormValid'
      :loadingButtons='isUploading'
      saveText='Upload'
      :color='getColor'
      :title='fieldName ? ("Add " + fieldName) : "Add Other File"'
      @save='uploadFile'
      @cancel='closeFileUploadModal'>
        <v-form v-model='isFormValid'>
          <v-file-input
            label='Choose file'
            v-model='fileToBeUploaded'
            :rules="[(fileSelected) || 'Please select a file']"
          ></v-file-input>
        </v-form>
    </wc-dialog>

    <wc-confirm-dialog
      width='400'
      :showDialog='showDeleteModal'
      saveText='Confirm delete'
      icon='mdi-alert'
      iconColor='error'
      saveColor='error'
      title='Delete file'
      :loadingButtons='isRemoving'
      :loading='isRemoving'
      @confirm='removeFile'
      @cancel='showDeleteModal=false'>
      <p> Are you sure you want to delete this file?</p>
    </wc-confirm-dialog>
  </tr>
</template>

<script>
import filesAPI from '@/api/files';
import WCConfirmDialog from '@/components/dialogs/WCConfirmDialog';
export default {
  name: 'wc-file',
  props: {
    file: {
      required: true
    },
    fieldName: {
      required: true,
      default: ''
    },
    // this needs to be more generic, like `objID` so we can use it on projects, estimates, and WOs, etc
    // Perhaps have multiple OPTIONAL props, so we can more easily figure out what type of obj is using
    // the component
    objId: {
      required: true,
      type: Number
    },
    // This will be used to determine if we are uploading a file to an `estimate`, `project` or `wo`
    // MUST BE: `estimate` `project` or `wo` <-- add to this list if other Objects can have files
    objType: {
      required: true,
      type: String
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  components: {
    'wc-confirm-dialog': WCConfirmDialog
  },
  watch: {
    fileToBeUploaded () {
      this.fileSelected = true
    }
  },
  data: () => ({
    fileToBeUploaded: undefined,
    fileSelected: false,
    showDeleteModal: false,
    isRemoving: false,
    fileToBeRemoved: undefined,
    showFileUploadModal: false,
    isUploading: false,
    isFormValid: false,
    label: 'grey--text text-left'
  }),
  computed: {
    getColor() {
      if (this.fieldName == "Sketch") { return "info" }
      else if (this.fieldName == "Asbuilt") { return "success darken-1" }
      else if (this.fieldName == "First Call") { return "brown lighten-1" }
      else { return "primary" }
    }
  },
  methods: {
    async uploadFile () {
      this.isUploading = true
      const uploadItem = await filesAPI.getPresignedURL(this.fileToBeUploaded.name, this.objId, this.objType)
        console.log("uploadItem below - result of getPresignedURL")
        console.log(uploadItem)
      filesAPI.uploadToAWS(uploadItem.url, this.fileToBeUploaded).then(() => {
        this.$emit('fileUploaded', { 'id': uploadItem.id, 'type': this.fieldName, 'name': this.fileToBeUploaded.name })
        this.closeFileUploadModal()
      })
    },
    closeFileUploadModal () {
      this.showFileUploadModal = false
      this.isUploading = false
    },
    async downloadFile () {
      const downloadURL = await filesAPI.downloadFile((typeof this.file === 'number') ? this.file : this.file.id)
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = downloadURL
      link.click()
    },
    async removeFile () {
      this.isRemoving = true
      if (this.fieldName !== "Sketch" && this.fieldName !== "First Call" && this.fieldName !== "Asbuilt") { 
        await filesAPI.deleteFile(this.file.id)
        this.$emit('deleteFile', this.file.id)
      } else {
        this.$emit('deleteSpecialFile', this.fieldName)
        await filesAPI.deleteFile(this.file)
        // this might be fixed now that special filenames copied to a WO are appended with "...Copy" ie "SketchCopy"
        // this will likely function normally now ( MJ has fingers crossed )
      }
      this.isRemoving = false
      this.showDeleteModal = false
    },
    openFileUploadModal () {
      this.showFileUploadModal = true
      this.fileSelected = false
    },
    openRemoveModal () {
      this.showDeleteModal = true
    }
  }
}
</script>